import { render, staticRenderFns } from "./super_traindal.vue?vue&type=template&id=75ca15c5&"
import script from "./super_traindal.vue?vue&type=script&lang=js&"
export * from "./super_traindal.vue?vue&type=script&lang=js&"
import style0 from "./super_traindal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports